import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import { ArrowLeft } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    http.get(`/blogs/${slug}`).then((r) => setB(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err)
    return (
      <main className="bg-[#f5f0e8] min-h-screen flex items-center justify-center text-[#1c1c1c]">
        <Link to="/" className="font-display text-3xl text-[#c5a059]">Return to AZEFAC</Link>
      </main>
    );
  if (!b) return <main className="bg-[#f5f0e8] min-h-screen" />;

  return (
    <main data-testid="blog-detail" className="bg-[#f5f0e8] text-[#1c1c1c] grain">
      <Navbar solid />
      <article className="pt-32 pb-24 max-w-3xl mx-auto px-6">
        <Link to="/" className="inline-flex items-center gap-2 underline-label text-[#3d2b1f] hover:text-[#c5a059] mb-10">
          <ArrowLeft size={14} /> Back to Journal
        </Link>
        <div className="underline-label mb-5">{b.category} · {b.read_minutes} min read</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mb-8">{b.title}</h1>
        <div className="text-xs uppercase tracking-[0.32em] text-[#3d2b1f] mb-12">Published {b.published_at}</div>
        <div className="img-zoom aspect-[5/3] mb-12">
          <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover" />
        </div>
        <div className="text-[#1c1c1c] text-lg leading-relaxed whitespace-pre-wrap">{b.body}</div>
      </article>
      <Footer />
      <Chatbot />
    </main>
  );
}
